import { render } from "./SkillsMobile.vue?vue&type=template&id=8879e0dc"
import script from "./SkillsMobile.vue?vue&type=script&lang=js"
export * from "./SkillsMobile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/connorklaassen/Documents/Programming/cklaassen.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__